import Vue from 'vue'
const { i18n } = Vue

import MapDrawing from '../../views/MapDrawing'

export const partnerRoute = [
  {
    path: '/partner-map',
    name: 'partnerMap',
    component: MapDrawing,
    meta: {
      login: true,
      title: i18n.translate('pages.title.map'),
      icon: 'mdi-map-marker-radius-outline',
      roles: ['ROLE_PARTNER'],
    }
  },

  {
    path: '/partner-appointments',
    name: 'partnerAppointmentsList',
    component: () => import('@/views/AdminAppointmentList'),
    meta: {
      login: true,
      title: i18n.translate('pages.title.appointmentList'),
      icon: 'mdi-calendar-month',
      roles: ['ROLE_PARTNER',],
    },
  },

  {
    path: '/partner-invoices',
    name: 'partnerInvoices',
    component: () => import('@/views/invoices/partner/PartnerInvoices'),
    meta: {
      login: true,
      title: i18n.translate('pages.title.invoices'),
      icon: 'mdi-text-box-outline',
      roles: ['ROLE_PARTNER'],
    },
  },
]
